// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"05537d95","707":"880dd6de","736":"4242a8c6"}[chunkId] + ".chunk.js";
};